module.exports = __webpack_public_path__ + "static/media/photo-forgot-password.e5a87542.jpeg";